// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import style from './MyWishListBox.scss';
import icons from '../../../../assets/styles/icons.scss';

import type { WishList, WishListItem } from '../../../../entities';

type Props = {
  +wishList: WishList;
  +topWrapStyle?: string;
  +index: number;
  +handleShareOpen: (index: number) => void;
  +handleCreateOrEditModalOpen: (mode: string, index?: number) => void;
  +handleDeleteModalOpen: (index: number) => void;
};

export const MyWishListBoxEmpty = () =>
  <article className={classNames(style.wishListBoxWrap, style.empty)}/>

export default class MyWishListBox extends Component<Props> {

  getSubtypeIntl = (wishList: WishList) => {
    switch (wishList.subtype) {
      case 'PUBLIC':
        return 'myWishLists.box.list.public';
      case 'PRIVATE':
        return 'myWishLists.box.list.private';
      case 'UNLISTED':
        return 'myWishLists.box.list.shared';
      default:
        return 'myWishLists.box.list.shared';
    }
  };

  render() {
    const {
      wishList, handleCreateOrEditModalOpen,
      handleDeleteModalOpen, topWrapStyle, index, handleShareOpen,
    } = this.props;

    const wishListTypeIntl = this.getSubtypeIntl(wishList);

    return (
      <article className={style.wishListBoxWrap}>
        <Link className={style.wishListLinkableWrap}
              to={`/wish-list/${wishList.user.id}/${wishList.slug}`}>
          <section className={classNames(style.topWrap, topWrapStyle)}>
            <section className={style.content}>
              <div className={style.wishListImageWrap}>
                <img src={wishList.image}
                     alt="image"/>
              </div>
              <div className={style.textWrap}>
                <p className={style.title}>{wishList.name}</p>
                <FormattedMessage id={wishListTypeIntl}>{
                  txt => <p className={style.subtitle}>{txt}</p>
                }</FormattedMessage>
              </div>
            </section>
          </section>
          <hr/>
          <section className={style.bottomWrap}>
            <Fragment>
              {wishList.items.length ? new Array(9).fill({}).map((_, index: number) => (
                  <div key={index}
                       className={classNames(style.imageWrap, {[style.outline]: index >= wishList.items.length})}>
                    {index < wishList.items.length && wishList.items[index] &&
                    <img src={wishList.items[index].image} alt="image"/>}
                  </div>)) :
                <div className={style.noProducts}>
                  <i className={icons.iconPlusMedium}/>
                  <FormattedMessage id="myWishLists.box.addProduct">{
                    txt => <p className={style.addProduct}>{txt}</p>
                  }</FormattedMessage>
                </div>}
            </Fragment>
          </section>
        </Link>
        <section className={style.buttonsWrap}>
          <button className={style.delete}
                  onClick={() => handleDeleteModalOpen(index)}>
            <i className={icons.iconTrashcanMedium}/>
          </button>
          <button className={style.share}
                  onClick={() => handleShareOpen(index)}>
            <i className={icons.symbolShareDots}/>
          </button>
          <button className={style.edit}
                  onClick={() => handleCreateOrEditModalOpen('edit', index)}>
            <i className={icons.iconEditMedium}/>
          </button>
        </section>
      </article>
    );
  }
}

MyWishListBox.propTypes = {
  wishList: PropTypes.object.isRequired,
  topWrapStyle: PropTypes.string,
  index: PropTypes.number.isRequired,
  handleShareOpen: PropTypes.func.isRequired,
  handleCreateOrEditModalOpen: PropTypes.func.isRequired,
  handleDeleteModalOpen: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/my-wish-lists/components/MyWishListBox/MyWishListBox.jsx